import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';
import { NativeScrollEvent } from 'react-native';
import { NativeSyntheticEvent } from 'react-native';

export const OverlayContext = createContext<TOverlayContext>({
  close: () => {},
  scrolled: false,
  onScroll: () => {},
});

export const useOverlay = () => {
  const contextValue = useContext(OverlayContext);
  if (!contextValue) {
    throw new Error('useOverlay should be inside a OverlayContext');
  }
  return contextValue;
};

export function OverlayProvider({ onClose, children }: TOverlayProviderProps) {
  const [scrolled, setScrolled] = useState(false);

  const onScroll = useCallback(
    (evt: NativeSyntheticEvent<NativeScrollEvent>) => {
      setScrolled(evt.nativeEvent.contentOffset.y >= 1);
    },
    []
  );

  return (
    <OverlayContext.Provider value={{ close: onClose, scrolled, onScroll }}>
      {children}
    </OverlayContext.Provider>
  );
}

export type TOverlayContext = {
  close: () => void;
  scrolled?: boolean;
  onScroll: (evt: NativeSyntheticEvent<NativeScrollEvent>) => void;
};

export type TOverlayProviderProps = {
  onClose: () => void;
  children: ReactNode;
};
